<template>
    <div>
        <cityinfo-header></cityinfo-header>
        <div class="inner-banner">
            <section class="w3l-breadcrumb">
                <div class="container py-md-4">
                    <div class="title-heading-w3 text-center mx-auto">
                        <h3 class="title-main" >{{title}}</h3>
                        <div class="mt-4 sub-title text-center">
                            <h4 class="mark-s">相關連結</h4>
                        </div>
                    </div>
                </div>
            </section>
            <section class="w3l-form-26">
		<div class="w3l-new-block-6 py-5">
			<div class="container py-md-4 py-3">
                <div class="form-inner-cont">
                    <div class="main-table1">
                        <table class="table1">
                            <thead>
                                <tr>
                                    <th>名稱</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in relatedLinksList" :key="i" :style="(i % 2 == 1? `background-color:#dee2e6;`:`background-color:#ffffff;`)" >
                                    <td data-title="名稱" class="text-center">
                                        <a href="javascript:;" @click="onGoUrl(item.linkUrl)" >{{item.title}}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row mt-md-5 mt-3">
                        <div class="col-12 text-center">
                            <div class="btn btn-style">
                                <button type="button" class="btn" @click="$router.go(-1);">返回</button>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		</div>
	 </section>
        </div>
        <cityinfo-footer></cityinfo-footer>
    </div>
</template>
<script>
import header from "./header";
import footer from './footer';
export default {
    components:{
        "cityinfo-header":header,
        "cityinfo-footer":footer
    },
    data(){
        return {
            title:"",
            dept:"",
            relatedLinksList:[],
        }
    },
    mounted(){
        if(this.getStore(this.$route.name)){
            let param = JSON.parse(this.getStore(this.$route.name));
            this.title = param.title;
            this.dept = param.dept;
        }
        this.loadInit();
    },
    methods:{
        loadInit(){
            this.$http.get(`/api/RelatedLinks/public`,{params:{dept:this.dept}}).then(a => {
                this.relatedLinksList = a.body;
            });
        },
        downloadPFile(obj){
            this.$http.post("/api/Share/fileDownload",JSON.stringify({
                model:obj.filePath,
            }),{
                headers: { "Content-Type": "application/json" },
                responseType: "blob" 
            }).then(res => {
                this.downloadFile(res.body, obj.fileName);
            }).catch(err => {
                console.log(err);
            });
        },
        onGoUrl(url){
            // 確保 url 是字串類型
            const urlString = String(url || '');
            
            // 使用 SweetAlert2 風格的 bootbox.confirm (只接受 message 和 callback)
            bootbox.confirm(
                '您即將前往下列網址, 請確認! <br/>' + urlString,
                function(result){
                    if(result){
                        let link = document.createElement("a");
                        link.href = urlString;
                        link.target = "_blank";
                        link.click();
                    }
                }
            );
        },
    },
    beforeRouteLeave(to, from, next) {
        this.removeStore(this.$route.name);
		next();
	}
}
</script>